export const environment = {
	production: true,
	dev: false,
	version: '0',
	pdt: {
		pais: { code: 'mx', name: 'México' },
		region: { region: 'Ciudad de México', country: 'mx' },
		fon: { idFon: 50, codigoForPag: 1, idMdl: 0, codigo: '01', fon: 'Efectivo', idMon: 'MXN', baja: 0 },
		regFis: { codigo: '601', regFis: "General de Ley Personas Morales" }
	},
	apiURL: 'https://mi.oadmin.app/',
	betaURL: '/beta/', // app React (migración) en el MISMO dominio; vacío = desactiva el aviso
	socketsURL: 'https://mi.oadmin.app/',
	mercadolibreRedirectUrl: 'https://mi.oadmin.app/',
	mercadolibreApiKey: '5597918279828242', // public
	stripeKey: 'pk_live_UR5viVoDzfxhN3vM49LohXYI00Tg42YUqo',
	paypalToken: 'A21AAGO2hXskMjlC14RAKzWLWE-ocrJcmVCAM6AgZ1v4jNoOZdmz80OMHh4CgvzPjjxI9YzobsojYd5QVSeaOa7rskXb73_Fg',
	vapidPublicKey: 'BMqda28A7qr68on2XilLNUilkGOLu4Ks94kL-OlZF-O2rX1EghlzuHNly1C12QqVpz3UypEM7n4Cp9jMB_8VRLQ',
	// shopifyApiKey: '88b29d9540eff5654851c50d032e0125', // custom
	amazonAppId: 'amzn1.sellerapps.app.708b8005-83ee-46c6-aa50-69f782023722', // public
	shopifyApiKey: '9e46ee4609cf70b557d267fc08296fc5',
	datosTesting: {
		email: '',
		nombre: '',
		apellido: '',
		tel: '',
		pass: '',
		fcp: {
			nom: '',
			ape: '',
			fcp: '',
			email: '',
			tel: '',
			envDom: '',
			envDomNro: '',
			envDomInt: '',
			envDomCodPos: '',
			envDomCol: '',
			envDomCiu: 'Ciudad de México',
			envDomMun: '',
			envDomRegion: { country: 'mx', region: 'Ciudad de México' },
			envDomPais: { code: 'mx', name: 'México' },
			usu: {
				usu: '',
				pass: ''
			}

		}
	}
};
